import * as React from 'react';
import styled from 'styled-components';
import { DefaultHashHintProps } from '../constants';
import { prepare } from '../utils';
import { HashHintList } from './HashHintList';
const HintContainer = styled.div `
  border-radius: 2px;
  box-shadow: 2px 5px 20px 0 rgba(0, 0, 0, 0.3);
  margin: 10px 0;
  max-height: 140px;
  overflow: auto;
  position: absolute;
  bottom: 64px;
`;
export const filterData = (data, filter) => {
    const value = filter.toLowerCase();
    return data.filter((item) => {
        return item.label.toLowerCase().search(value) !== -1;
    });
};
export class HashHint extends React.Component {
    constructor(props) {
        super(props);
        this.isEmpty = false;
        this.lastFocusedIndex = [];
        this.list = null;
        this.prev = () => {
            return this.list.focusOnPrev();
        };
        this.next = () => {
            return this.list.focusOnNext();
        };
        this.select = (index) => {
            return this.list.select(index);
        };
        this.ref = (list) => {
            this.list = list;
        };
        this.onPrev = () => {
            return this.back();
        };
        this.onSelect = ({ label, next }, index) => {
            const { onSelect } = this.props;
            if (!next) {
                if (onSelect) {
                    onSelect(label);
                }
                return;
            }
            const { filterReset, maxWidth: width } = this.props;
            const state = {
                data: next,
                focusedIndex: 0,
                width
            };
            if (filterReset) {
                const { filter } = DefaultHashHintProps;
                state.filter = filter;
            }
            this.setState(state, () => {
                this.lastFocusedIndex.push(index);
            });
        };
        const { data, filter, focusedIndex, minWidth: width } = props;
        this.state = {
            data: prepare(data),
            filter,
            // filteredData: prepare(data),
            focusedIndex,
            width
        };
    }
    componentWillReceiveProps(next) {
        // prev: HashHintProps
        this.setState(() => {
            const { filter } = next;
            return { filter };
        });
    }
    back() {
        const { data } = this.state;
        const prev = data[0].prev;
        if (!prev) {
            return false;
        }
        const { lastFocusedIndex } = this;
        const { filterReset, minWidth: width } = this.props;
        const [focusedIndex] = lastFocusedIndex.slice(-1);
        const state = {
            data: prev,
            focusedIndex,
            width
        };
        if (filterReset) {
            const { filter } = this.props;
            state.filter = filter;
        }
        this.setState(state, () => {
            lastFocusedIndex.pop();
        });
        return true;
    }
    render() {
        const { onPrev, onSelect } = this;
        const { data, filter, focusedIndex, width } = this.state;
        const items = filter ? filterData(data, filter) : data;
        this.isEmpty = items.length === 0;
        return (React.createElement(HintContainer, null,
            React.createElement(HashHintList, { ref: this.ref, focusedIndex: focusedIndex, items: items, width: width, onPrev: onPrev, onSelect: onSelect })));
    }
}
HashHint.defaultProps = Object.assign({}, DefaultHashHintProps);
//# sourceMappingURL=HashHint.js.map